import Loading from "components/Loading";
import { classNames } from "utils/helpers";

type RestProps = {
  form?: undefined | string;
};

type Props = {
  type?: any;
  enabled?: boolean;
  loading?: boolean;
  label?: string;
  onClick?: Function;
  secondary?: boolean;
  full?: boolean;
  small?: boolean;
  submitFormName?: string;
};

export default function CTAButton({
  type = "button",
  enabled = true,
  loading = false,
  label = "Submit",
  secondary = false,
  full = false,
  small = false,
  submitFormName,
  onClick,
}: Props) {
  const handleOnClick = () => onClick && enabled && onClick();

  const rest: RestProps = {};

  if (submitFormName) {
    rest.form = submitFormName;
  }

  if (loading) {
    return (
      <div className="justify-center px-4">
        <Loading />
      </div>
    );
  }

  return (
    <button
      type={type}
      disabled={!enabled}
      className={classNames(
        !enabled ? "opacity-50" : "cursor-pointer",
        full ? "flex w-full" : "",
        secondary
          ? " border-brand-green-dark bg-white hover:bg-gray-50"
          : "border-brand-green-medium bg-brand-green-medium text-white hover:border-brand-green-dark hover:bg-brand-green-dark",
        small ? "px-3 py-1 text-sm" : "px-7 py-2 text-base",
        "justify-center rounded-md border font-semibold shadow-md",
      )}
      onClick={handleOnClick}
      {...rest}
    >
      {label}
    </button>
  );
}
